<div class="meeting-records-list-header">
  @if (!is_discarded()) {
    <a
      mat-flat-button
      color="accent"
      [routerLink]="['/employees', 'rrhh', 'job-vacancies', job_vacancy_id(), 'candidates', job_candidate_id(), 'meeting-records', 'new']"
    >
      Nueva acta
    </a>
  }
</div>

@if (loading()) {
  <p class="muted">Cargando actas...</p>
} @else if (meeting_records().length === 0) {
  <p class="muted">No hay actas registradas.</p>
} @else {
  <ul class="meeting-records-list">
    @for (meeting_record of meeting_records(); track meeting_record.id) {
      <li>
        <div class="meeting-record-row">
          <a
            class="meeting-record-link"
            [routerLink]="[
              '/employees',
              'rrhh',
              'job-vacancies',
              job_vacancy_id(),
              'candidates',
              job_candidate_id(),
              'meeting-records',
              meeting_record.id,
            ]"
          >
            <strong>
              {{ meeting_record.phase_name }}
              · {{ meeting_record.created_at | date: 'dd/MM/yyyy HH:mm' }}
            </strong>
            @if (resolveEvaluationForMeetingRecord(meeting_record); as evaluation) {
              @if (evaluation.exam_instance?.name) {
                <p class="meeting-record-excerpt">
                  Examen: {{ evaluation.exam_instance?.name }} · {{ evaluationStatusLabel(meeting_record) }}
                </p>
              }
            }
            @if (meeting_record.content_excerpt) {
              <p class="meeting-record-excerpt">{{ meeting_record.content_excerpt }}</p>
            }
          </a>
          @if (!is_discarded()) {
            <div class="meeting-record-actions">
              @if (meeting_record.exam_instance_evaluation_id) {
                @if (evaluationDetailRouterLink(meeting_record); as evaluation_detail_link) {
                  <a mat-icon-button matTooltip="Ver evaluación" aria-label="Ver evaluación" [routerLink]="evaluation_detail_link">
                    <mat-icon>fact_check</mat-icon>
                  </a>
                }
              }
              <a
                mat-icon-button
                matTooltip="Editar acta"
                aria-label="Editar acta"
                [routerLink]="[
                  '/employees',
                  'rrhh',
                  'job-vacancies',
                  job_vacancy_id(),
                  'candidates',
                  job_candidate_id(),
                  'meeting-records',
                  meeting_record.id,
                ]"
              >
                <mat-icon>edit</mat-icon>
              </a>
              <button
                mat-icon-button
                type="button"
                color="warn"
                matTooltip="Eliminar acta"
                aria-label="Eliminar acta"
                (click)="deleteMeetingRecord(meeting_record)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      </li>
    }
  </ul>
}
